import { render, staticRenderFns } from "./SimpleSelect.vue?vue&type=template&id=281b0e5e&"
import script from "./SimpleSelect.vue?vue&type=script&lang=ts&"
export * from "./SimpleSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports